export const BLOG_POST_FIELDS = /* groq */ `
  _id,
  title,
  "slug": slug.current,
  excerpt,
  mainImage,
  publishedAt,
  "category": category->{ _id, title, "slug": slug.current }
`;

export const BLOG_POSTS_LIST_QUERY = /* groq */ `
  *[_type == "post" && publishedAt <= now()] | order(publishedAt desc) {
    ${BLOG_POST_FIELDS}
  }
`;

export const BLOG_POST_BY_SLUG_QUERY = /* groq */ `
  *[_type == "post" && slug.current == $slug && publishedAt <= now()][0] {
    ${BLOG_POST_FIELDS},
    body
  }
`;

export const BLOG_CATEGORIES_QUERY = /* groq */ `
  *[_type == "category"] | order(title asc) {
    _id,
    title,
    "slug": slug.current
  }
`;
